import { jsxs as j, jsx as s } from "react/jsx-runtime";
import _, { createContext as $, useState as r, useEffect as B } from "react";
import { Banner as E } from "../../components/Banner/index.js";
import { ToastContainer as R } from "./style.js";
const q = {
  showToast: () => {
  },
  closeToast: () => {
  }
}, a = $(q);
function G({ children: c }) {
  const [l, u] = r({
    text: "",
    duration: 2500
  }), [o, e] = r(!1), {
    text: T,
    titleText: m,
    bannerType: f,
    icon: p,
    rightIcon: x,
    onClick: C,
    duration: n,
    topPosition: P,
    bottomPosition: d
  } = l;
  B(() => {
    const t = o && setTimeout(() => {
      e(!1);
    }, n);
    return () => {
      t && clearTimeout(t);
    };
  }, [n, o]);
  const h = ({
    text: t,
    titleText: b,
    icon: w,
    rightIcon: I,
    duration: g = n,
    topPosition: k,
    bottomPosition: v,
    bannerType: y,
    onClick: S
  }) => {
    u({
      text: t,
      titleText: b,
      icon: w,
      rightIcon: I,
      onClick: S,
      duration: g,
      topPosition: k,
      bottomPosition: v,
      bannerType: y
    }), e(!0);
  }, i = () => {
    e(!1);
  };
  return /* @__PURE__ */ j(
    a.Provider,
    {
      value: {
        showToast: h,
        closeToast: i
      },
      children: [
        c,
        o && /* @__PURE__ */ s(
          R,
          {
            $topPosition: P,
            $bottomPosition: d,
            children: /* @__PURE__ */ s(
              E,
              {
                caption: T || "",
                onClose: i,
                leftIcon: p,
                rightIcon: x,
                onClick: C,
                title: m,
                bannerType: f,
                role: "alert"
              }
            )
          }
        )
      ]
    }
  );
}
const H = () => _.useContext(a);
export {
  a as Context,
  G as ToastProvider,
  H as useToast
};
